import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ShopSettings, ShopSettingsRepository } from '@infrab4a/connect';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';

import { FileControllerService } from 'src/app/admin-api';
import { CustomizationFormComponent } from 'src/app/components/customization/customization-form.component';
import { ImageService } from 'src/app/services/image.service';
@Component({
  selector: 'app-mens',
  templateUrl: './mens.component.html',
  styleUrls: ['./mens.component.scss']
})
export class MensComponent
  extends CustomizationFormComponent
  implements OnInit
{
  pageDocument: ShopSettings;

  constructor(
    @Inject('ShopSettingsRepository')
    private shopSettingsRepository: ShopSettingsRepository,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    override router: Router,
    override config: PrimeNGConfig,
    override imageService: ImageService,
    override fileService: FileControllerService
  ) {
    super(router, config, imageService, fileService);

    this.documentId = 'MENS';

    this.form = this.formBuilder.group({
      descriptionMeta: ['', [Validators.required, Validators.maxLength(255)]],
      titleMeta: ['', Validators.required],
      imageMeta: ['']
    });
  }

  async ngOnInit() {
    await this.getDocument();
  }

  override async getDocument(): Promise<void> {
    try {
      this.pageDocument = await this.shopSettingsRepository.get({
        id: this.documentId
      });

      this.initializeForm();
    } catch (error) {
      this.form.patchValue(this.pageDocument);
    }
  }

  override initializeForm(): void {
    this.form.patchValue(this.pageDocument);
  }

  override async save() {
    if (this.form.valid) {
      await this.shopSettingsRepository.update({
        id: this.documentId,
        ...this.form.value
      });

      await this.afterSubmit();

      this.messageService.add({
        severity: 'success',
        summary: 'Salvo com sucesso',
        detail: 'As informações foram salvas.'
      });
    } else {
      console.error('Formulário inválido. Não é possível salvar os dados.');
    }
  }

  isMetaTitleInvalid() {
    const metaTitleControl = this.form.get('titleMeta');
    return (
      metaTitleControl?.invalid &&
      (metaTitleControl?.touched || metaTitleControl?.dirty)
    );
  }

  isMetaDescriptionInvalid() {
    const metaDescriptionControl = this.form.get('descriptionMeta');
    return (
      metaDescriptionControl?.invalid &&
      (metaDescriptionControl?.touched || metaDescriptionControl?.dirty)
    );
  }

  async handleFileSelect(
    event: { files: File[] },
    inputName: string,
    expectedWidth: number,
    expectedHeight: number,
    maxWeight: number,
    pInput: FileUpload
  ) {
    this.fileNamePattern = `mens-meta-${new Date().getTime()}.webp`;

    await this.upload(
      event,
      inputName,
      expectedWidth,
      expectedHeight,
      maxWeight,
      pInput
    );
  }

  goToCarousels() {
    this.navigate('configuracoes/mens/carousels');
  }

  goToMenu() {
    this.navigate('configuracoes');
  }
  get metaImageUrl(): string {
    return this.form.get('imageMeta')?.value;
  }

  override get filePath(): string {
    return '/pages/mens/';
  }

  override get model() {
    return this.pageDocument;
  }

  override get modelId() {
    return this.pageDocument?.id;
  }
}
